
import React from 'react';
import BiasOpsLanding from './components/BiasOpsLanding';
export default function App() { return <BiasOpsLanding />; }
